import React from 'react';
import { connect } from 'react-redux';
import CommonService from '../../../../services/commonService';
import 'react-slideshow-image/dist/styles.css';

import { Fade } from 'react-slideshow-image';

const fadeProperties = {
  // duration: 4000,
  pauseOnHover: false,
  // autoplay: true,
  indicators: true,
  arrows: false,
};

const ThemeThreeSlider = props => {
  const operator = CommonService.getLocal('op') || props.home.operator;
  return (
    <div className="themes-theme-three-slider new-container">
      <style>
        .react-slideshow-container + ul.indicators .each-slideshow-indicator.active:before{'{'}
        background:{' '}
        {operator &&
          operator.color_codes &&
          operator.color_codes.secondary_color &&
          operator.color_codes.secondary_color}
        {'}'}
      </style>
      <Fade {...fadeProperties}>
        {props.slides &&
          (props.slides || []).map((slide, index) => (
            <div className="grid-container" key={index}>
              <figure className="item1">
                <img className="image" src={slide.one} alt="slide-item" />
              </figure>
              <figure className="item2">
                <img className="image" src={slide.two} alt="slide-item" />
              </figure>
              <figure className="item3">
                <img className="image" src={slide.three} alt="slide-item" />
              </figure>
              <figure className="item4">
                <img className="image" src={slide.four} alt="slide-item" />
              </figure>
            </div>
          ))}
      </Fade>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
  };
}

// /* istanbul ignore next */
// function mapDispatchToProps(dispatch) {
//   return {
//     actions: bindActionCreators({ ...actions }, dispatch)
//   };
// }

export default connect(mapStateToProps, {})(ThemeThreeSlider);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeThree/common/ThemeThreeSlider.js